
const checkError = (validationErrors, item) => {
  const IsError = validationErrors?.find(v => v.field == item);

  if (IsError !== undefined) {

    return IsError;

  } else {
    return false;
  }
};

export default checkError;

